import { BasePageDto } from "@/types/dto/base-page-dto";
import { UserDto } from "@/types/dto/user-dto";

export interface NoticeDetailDto {
  id: number;
  title: string;
  thumbnail: string;
  content: string;
  fileUrls: string[];
  views: number;
  createdAt: Date;
  updatedAt: Date;
  popupStartDate?: Date;
  popupEndDate?: Date;
  user: UserDto;
}

export const initNoticePage: BasePageDto<NoticeDetailDto> = {
  contents: [],
  currentPage: 1,
  totalElements: 0,
  totalPage: 1,
  isFirst: true,
  isLast: true,
};
